import { IAppState } from '../../../store/rootDuck';

export const selectCart = (state: IAppState) => state.cart.cart;
export const selectGuestCart = (state: IAppState) => state.cart.guestCart;
export const selectCheckoutLoading = (state: IAppState) => state.cart.checkoutLoading;
export const selectAddProductLoading = (state: IAppState) => state.cart.addProductLoading;
export const selectCheckoutSuccess = (state: IAppState) => state.cart.checkoutSuccess;
export const selectCheckoutError = (state: IAppState) => state.cart.checkoutError;

export const selectMe = (state: IAppState) => state.profile.me;
export const selectIsAdmin = (state: IAppState) => state.profile.me?.is_admin;
export const selectIsAuthorized = (state: IAppState) => state.auth.user != null;

export const selectStores = (state: IAppState) => state.cart.stores;

export const selectByCoordsAddress = (state: IAppState) => state.yaLocations.addressByCoords;
export const selectByCoordsSuccess = (state: IAppState) => state.yaLocations.getLoacationByCoordsSuccess;
export const selectYalocations = (state: IAppState) => state.yaLocations.yaLocations;
export const selectLoadingYalocations = (state: IAppState) => state.yaLocations.loading;
export const selectLoadingByIdYalocaitons = (state: IAppState) =>
  state.yaLocations.getLoacationByCoordsLoading;
